import { render, staticRenderFns } from "./PoisListView.vue?vue&type=template&id=3d584f66&scoped=true&"
import script from "./PoisListView.vue?vue&type=script&lang=js&"
export * from "./PoisListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d584f66",
  null
  
)

export default component.exports